import { Switch } from "antd";
import PrimaryButton from "../buttons/PrimaryButton";
import Icon1 from "../icons/Icon";
import DropDownGPT03 from "../dropdowns/DropDownGTP03";
import WarningButton from "../buttons/WarningButton";

export const EasySwitch = ({
  disabled = false,
  checked = false,
  onChange = {},
  size = "small",
}) => {
  return (
    <Switch
      size={size}
      style={{
        backgroundColor: checked ? "#6366F1" : "#E5E7EB",
      }}
      checked={checked === null ? false : checked}
      onChange={onChange}
      disabled={disabled}
    ></Switch>
  );
};

export const ToggleSettingsBrick = ({
  checked,
  onChange,
  title,
  description,
  disabled,
}) => {
  return (
    <div className="text-h3 text-shadow_50 font-normal items-start p-2 rounded-lg border-1  flex flex-row gap-4">
      <div className="flex flex-col pt-1">
        <EasySwitch disabled={disabled} checked={checked} onChange={onChange} />
      </div>
      <div className="flex flex-col gap-1">
        <div className="font-medium text-black">{title}</div>
        <div className="text-shadow_50">{description}</div>
      </div>
    </div>
  );
};

export const DropDownSettingsBrick = ({
  value,
  onChange,
  title,
  description,
  disabled,
  items,
  label,
  icon_name = "horloge",
}) => {
  return (
    <div className="text-h3 text-shadow_50 font-normal items-start p-2 rounded-lg border-1  flex flex-col gap-4">
      <div className="flex flex-row gap-6">
        <Icon1 icon_name={icon_name} fill="grey" size={20} />
        <div className="flex flex-col gap-1 mb-1">
          <div className="font-medium text-black">{title}</div>
          <div className="text-shadow_50 mb-1">{description}</div>

          <DropDownGPT03
            items={items}
            label={label}
            disabled={disabled}
            value={value}
            onChange={onChange}
          />
        </div>
      </div>
    </div>
  );
};

export const TogglePlanBrick = ({
  icon_name,
  className,
  icon,
  checked,
  onChange,
  disabled,
  title,
  description,
  price = "",
}) => {
  return (
    <div
      className={`
    ${className ? className : "border-1"}
    text-h3 text-shadow_50 font-normal items-start w-fit p-2 rounded-lg  mb-2  flex flex-col gap-4`}
    >
      <div className="flex flex-col ">
        <div className="flex flex-row items-center  rounded-md gap-3">
          {icon ? icon : <Icon1 icon_name={icon_name} size={25}></Icon1>}
          <div className="font-medium text-black mr-auto">{title}</div>
          <EasySwitch
            checked={checked}
            onChange={onChange}
            disabled={disabled}
          />
        </div>
        <div className="flex flex-col gap-2 max-w-c500 mt-2">
          <div className="text-shadow_50 ">{description}</div>
          <div className="text-gray-400 font-semibold">{price}</div>
        </div>
      </div>
    </div>
  );
};

export const SettingsBrick = ({ title, description, children }) => {
  return (
    <div className="text-h3 text-shadow_50 font-normal items-start p-2 rounded-lg border-1 mb-2 max-w-c500 w-full flex flex-row gap-4">
      <div className="flex flex-col gap-1">
        <div className="font-medium text-black">{title}</div>
        <div className="text-shadow_50">{description}</div>
        <div className="flex flex-col gap-1 mt-2">{children}</div>
      </div>
    </div>
  );
};

export const SaveBar = ({ condition, onClick }) => {
  return (
    <>
      {condition && (
        <div className="fixed top-10 right-10 m-4 z-50">
          <div className="bg-white hover:animate-none  animate-small-bounce shadow-md rounded-lg outline-none outline2 outline-red-400 p-4 flex flex-col gap-3">
            <div className="text-h3 font-normal w-c300 text-black">
              Vous devez enregistrer les modifications pour qu'elles soient
              prises en compte.
            </div>
            <WarningButton onClick={onClick} className={"w-fit h-fit "}>
              Enregistrer les modifications
            </WarningButton>
          </div>
        </div>
      )}
    </>
  );
};

export const ToggleLogementBrick = ({
  checked,
  onChange,
  title,
  description,
  disabled,
}) => {
  return (
    <div className="text-h3 text-shadow_50  font-normal items-start p-2 rounded-lg border-1    flex flex-row gap-4">
      <div className="flex flex-col pt-1">
        <EasySwitch disabled={disabled} checked={checked} onChange={onChange} />
      </div>
      <div className="flex flex-col gap-1">
        <div className="font-medium text-black flex flex-row items-center gap-2 justify-between">
          {title}
          <Icon1 icon_name="hexagone-logement" size={20}></Icon1>
        </div>
        <div className="text-shadow_50">{description}</div>
      </div>
    </div>
  );
};
